export const LAW = {
  Law159: 'LAW159', // قانون 159 لسنة 1981
  Law72: 'LAW72',   // قانون 72 لسنة 2017

} as const;

export const LEGAL_SITUATION = {
  JointStock: 'JSC',           // شركة مساهمة
  GeneralPartnership: 'PART',  // شركة تضامن
  LimitedPartnership: 'LP',    // شركة توصية بسيطة
  LimitedLiability: 'LLC',     // شركة ذات مسؤولية محدودة
  PartnershipByShares: 'LP_SHARES', // شركة توصية بالأسهم
  OnePersonCompany: 'OPC',     // شركة الشخص الواحد
  SoleProprietorship: 'SOLE',  // منشأة فردية
} as const;

export const ESTABLISHMENT_TYPE = {
  Normal: 'NORMAL',     // عادي
  Conversion: 'TRANS',  // تحول
  Division: 'SPLIT',    // انقسام
  DeFacto: 'REALITY',   // واقع
} as const;

export const INVESTMENT_NATURE = {
  Internal: 'INT',      // استثمار داخلي
  FreeZone: 'FZ',       // مناطق حرة
} as const;

export const FREE_ZONE_TYPE = {
  Public: 'FZG',   // المنطقة الحرة العامة
  Private: 'FZP', // المنطقة الحرة الخاصة
} as const;


export const PARTNER_STATUS_CODE = {
  JOINT: 'JOINT',     // متضامن
  TESTATOR: 'TESTATOR', // موصى
  PARTNER: 'PARTNER',   // شريك
  SHAREHOLDER: 'SHAREHOLDER', // مساهم
} as const;


export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE'
}
// Extract from the Java code the Company Type and Scenario mapping

export interface CompanyTypeMapping {
  code: string;
  nameEn: string;
  nameAr: string;
  companyType: string;
}

export interface ScenarioMapping {
  legalSituationCode: string;
  lawCode: string;
  scenarioName: string;
}

// Company Type Mappings
export const COMPANY_TYPE_MAPPINGS: CompanyTypeMapping[] = [
  {
    code: 'LLC',
    nameEn: 'LIMITED_LIABILITY',
    nameAr: 'الشركة ذات المسؤولية المحدودة',
    companyType: 'LIMITED_LIABILITY'
  },
  {
    code: 'OPC',
    nameEn: 'ONE_PERSON_LLC',
    nameAr: 'شركة الشخص الواحد ذات المسؤولية المحدودة',
    companyType: 'ONE_PERSON_LLC'
  },
  {
    code: 'JSC',
    nameEn: 'JOINT_STOCK',
    nameAr: 'شركة المساهمة',
    companyType: 'JOINT_STOCK'
  },
  {
    code: 'LP_SHARES',
    nameEn: 'LIMITED_BY_SHARES',
    nameAr: 'شركة التضامن بأسهم',
    companyType: 'LIMITED_BY_SHARES'
  },
  {
    code: 'PART',
    nameEn: 'PARTNERSHIP',
    nameAr: 'شركة التضامن',
    companyType: 'PARTNERSHIP'
  },
  {
    code: 'LP',
    nameEn: 'LIMITED_PARTNERSHIP',
    nameAr: 'شركة التوصية البسيطة',
    companyType: 'LIMITED_PARTNERSHIP'
  },
  {
    code: 'SOLE',
    nameEn: 'SOLE_PROPRIETORSHIP',
    nameAr: 'المشروع الفردي',
    companyType: 'SOLE_PROPRIETORSHIP'
  }
];

// Scenario Mappings based on Legal Situation and Law
export const SCENARIO_MAPPINGS: ScenarioMapping[] = [
  // Law 159 - LLC
  {
    legalSituationCode: 'LLC',
    lawCode: 'LAW159',
    scenarioName: 'LLC_LAW_159'
  },
  // Law 72 - LLC
  {
    legalSituationCode: 'LLC',
    lawCode: 'LAW72',
    scenarioName: 'LLC_LAW_8'
  },
  // Law 159 - OPC
  {
    legalSituationCode: 'OPC',
    lawCode: 'LAW159',
    scenarioName: 'LLC_LAW_159'
  },
  // Law 72 - OPC
  {
    legalSituationCode: 'OPC',
    lawCode: 'LAW72',
    scenarioName: 'LLC_LAW_8'
  },
  // Law 159 - Joint Stock
  {
    legalSituationCode: 'JSC',
    lawCode: 'LAW159',
    scenarioName: 'JOINT_STOCK_LAW_159'
  },
  // Law 72 - Joint Stock
  {
    legalSituationCode: 'JSC',
    lawCode: 'LAW72',
    scenarioName: 'JOINT_STOCK_LAW_8'
  },
  // Law 159 - Limited by Shares
  {
    legalSituationCode: 'LP_SHARES',
    lawCode: 'LAW159',
    scenarioName: 'CAPITAL_LIMITS_ONLY'
  },
  // Law 72 - Limited by Shares
  {
    legalSituationCode: 'LP_SHARES',
    lawCode: 'LAW72',
    scenarioName: 'CAPITAL_LIMITS_ONLY'
  },
  // Partnership
  {
    legalSituationCode: 'PART',
    lawCode: 'LAW159',
    scenarioName: 'PARTNERSHIP'
  },
  {
    legalSituationCode: 'PART',
    lawCode: 'LAW72',
    scenarioName: 'PARTNERSHIP'
  },
  // Limited Partnership
  {
    legalSituationCode: 'LP',
    lawCode: 'LAW159',
    scenarioName: 'PARTNERSHIP'
  },
  {
    legalSituationCode: 'LP',
    lawCode: 'LAW72',
    scenarioName: 'PARTNERSHIP'
  },
  // Sole Proprietorship
  {
    legalSituationCode: 'SOLE',
    lawCode: 'LAW159',
    scenarioName: 'SOLE_PROPRIETORSHIP'
  },
  {
    legalSituationCode: 'SOLE',
    lawCode: 'LAW72',
    scenarioName: 'SOLE_PROPRIETORSHIP'
  }
];
 
// Utility function to get Company Type
export function getCompanyType(legalSituationCode: string): string | null {
  const mapping = COMPANY_TYPE_MAPPINGS.find(
    m => m.code === legalSituationCode || m.nameEn === legalSituationCode
  );
  return mapping ? mapping.companyType : null;
}

// Utility function to get Scenario
export function getScenario(legalSituationCode: string, lawCode: string): string {
  const mapping = SCENARIO_MAPPINGS.find(
    m => m.legalSituationCode === legalSituationCode && m.lawCode === lawCode
  );
  return mapping ? mapping.scenarioName : 'capital_limits_only';
}

// Utility function to get scenario by legal situation and law code
export function deriveScenario(legalSituation: any, law: any): string {
  const legalCode = legalSituation?.code?.toUpperCase();
  const lawCode = law?.code?.toUpperCase();

  return getScenario(legalCode, lawCode);
}
export enum RelatedUserType {
  FOUNDER = 'FOUNDER',
  INVESTOR = 'INVESTOR',
  PARTNER = 'PARTNER',
  SHAREHOLDER = 'SHAREHOLDER'
}

export enum TypeOfPowerOfAtorney {
  GENERAL = 'GENERAL',
  SPECIAL = 'SPECIAL'
}

export const TYPE_OF_POWER_OF_ATORNEY_DISPLAY: Record<TypeOfPowerOfAtorney, string> = {
  [TypeOfPowerOfAtorney.GENERAL]: 'عام',
  [TypeOfPowerOfAtorney.SPECIAL]: 'خاص'
};